// @flow
import React from 'react'
import i18n from 'i18next'

import { Wrapper, Text } from './styles'

const Banner = () => (
  <Wrapper>
    <Text>{i18n.t('checkout.banner')}</Text>
  </Wrapper>
)

export default Banner
